var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.providerComponent && _vm.bookingData)?_c(_vm.providerComponent,{tag:"component",attrs:{"booking-data":_vm.bookingData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }